import { render, staticRenderFns } from "./GetToKnowUs.vue?vue&type=template&id=09bd2f05"
import script from "./GetToKnowUs.vue?vue&type=script&lang=js"
export * from "./GetToKnowUs.vue?vue&type=script&lang=js"
import style0 from "./GetToKnowUs.vue?vue&type=style&index=0&id=09bd2f05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports